import Swiper, { EffectFade, Navigation, Pagination } from 'swiper'
import loadMore from './modules'
;(() => {
  const burger = document.querySelector<HTMLButtonElement>(
    '.site-header-burger'
  )
  const mobileNav = document.querySelector('.mobile-header')

  if (!burger || !mobileNav) return

  const initialAriaLabel = burger.getAttribute('aria-label') ?? ''
  const closedAriaLabel = 'Zamknij nawigacje'
  const activeClass = 'site-header-burger-active'
  const mediaQuery = window.matchMedia('(max-width: 1280px)')

  const onOpen = () => {
    burger.setAttribute('aria-label', closedAriaLabel)
    burger.classList.add(activeClass)
    document.body.style.overflow = 'hidden'
    mobileNav.classList.add('mobile-header-visible')
  }

  const onClose = () => {
    burger.setAttribute('aria-label', initialAriaLabel)
    burger.classList.remove(activeClass)
    document.body.style.overflow = ''
    mobileNav.classList.remove('mobile-header-visible')
  }

  burger.addEventListener('click', () => {
    const hasActiveClass = burger.classList.contains(activeClass)

    if (hasActiveClass) {
      onClose()
    } else {
      onOpen()
    }
  })

  mediaQuery.addEventListener('change', ({ matches }) => {
    if (!matches) onClose()
  })
})()
;(() => {
  new Swiper('.team-swiper', {
    modules: [Pagination],
    slidesPerView: 1.5,
    spaceBetween: 16,
    breakpoints: {
      640: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1025: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1400: {
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
      1600: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
    pagination: {
      type: 'bullets',
      clickable: true,
      el: '.team .pagination',
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet-active',
    },
  })
})()
;(() => {
  new Swiper('.news-swiper', {
    modules: [Pagination, Navigation, EffectFade],
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      type: 'bullets',
      clickable: true,
      el: '.news-swiper .pagination',
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet-active',
    },
  })
})()
;(() => {
  new Swiper('.swiper-files', {
    modules: [Pagination],
    slidesPerView: 1.5,
    spaceBetween: 16,
    breakpoints: {
      640: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
    pagination: {
      type: 'bullets',
      clickable: true,
      el: '.swiper-files .pagination',
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet-active',
    },
  })
})()
;(() => {
  const toggleItems =
    document.querySelectorAll<HTMLDivElement>('.food-menu-item')

  toggleItems.forEach((item) => {
    item
      .querySelector<HTMLButtonElement>('.food-menu-item-toggle')
      ?.addEventListener('click', () => {
        item.classList.toggle('toggled')
      })
  })
})()
;(() => {
  new Swiper('.swiper-gallery', {
    modules: [Pagination],
    slidesPerView: 1.5,
    spaceBetween: 16,
    breakpoints: {
      1400: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
    pagination: {
      type: 'bullets',
      clickable: true,
      el: '.swiper-gallery .pagination',
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet-active',
    },
  })
})()
;(() => {
  const s = document.querySelector<HTMLDivElement>('.single-news-swiper')

  if (!s) return

  const swiper = new Swiper('.single-news-swiper', {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
  })

  document
    .querySelector<HTMLButtonElement>('.single-news-swiper-close')
    ?.addEventListener('click', () => {
      s.style.display = 'none'
      document.body.style.overflow = ''
    })

  document
    .querySelectorAll<HTMLDivElement>('.news-gallery-item')
    .forEach((el) => {
      el.addEventListener('click', () => {
        s.style.display = 'block'
        const { slideTo } = el.dataset
        if (slideTo) {
          swiper.slideTo(parseInt(slideTo))
          document.body.style.overflow = 'hidden'
        }
      })
    })
})()

loadMore('.btn-load-more', '.btn-load-more button', '.x-cards')
